import React from 'react'
import styles from './application-flow-retention-dialog.module.scss'

interface Props {
  amount?: string
  canClose: boolean
  illustrationSrc: string

  /** 点击关闭按钮（✕）：关闭弹窗，留在当前页 */
  onDismiss: () => void

  /** 点击「放弃插队机会」：退出表单页 */
  onLeave: () => void

  /** 点击「立即提交」：关闭挽留弹窗并触发提交 */
  onSubmit: () => void

  /** 提交进行中的 loading 状态 */
  submitting: boolean

  /** 挽留弹窗显隐状态 */
  visible: boolean
}

/**
 * ApplicationFlowRetentionDialog — 申请流程新皮肤通用插队挽留弹窗 UI 组件
 * @returns {React.ReactElement | null} 挽留弹窗节点
 */
const ApplicationFlowRetentionDialog: React.FC<Props> = ({
  amount = '200,000',
  canClose,
  illustrationSrc,
  onDismiss,
  onLeave,
  onSubmit,
  submitting,
  visible,
}) => {
  if (!visible) {
    return null
  }

  return (
    <div aria-label="插队特权" aria-modal="true" className={styles.mask} role="dialog">
      <section className={styles.card}>
        {canClose ? (
          <button aria-label="关闭挽留弹窗" className={styles.close} onClick={onDismiss} type="button">
            ✕
          </button>
        ) : null}
        <img alt="" className={styles.stamp} height="75" src={illustrationSrc} width="78" />
        <h2 className={styles.title}>
          恭喜您，<br />
          现在提交，可<span className={styles.highlight}>插队申请</span>
        </h2>
        <div className={styles.amountCard}>
          <div className={styles.amountLabel}>最高可借</div>
          <div className={styles.amountValue}>
            <span>¥</span>{amount}
          </div>
        </div>
        <button className={styles.primary} disabled={submitting} onClick={onSubmit} type="button">
          立即提交
        </button>
        <button className={styles.secondary} onClick={onLeave} type="button">
          放弃插队机会
        </button>
      </section>
    </div>
  )
}

export default React.memo(ApplicationFlowRetentionDialog)
